// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!

=========================================================
* Paper Kit React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
.tim-row {
  margin-bottom: 20px;
}

.tim-white-buttons {
  background-color: #777777;
}

.typography-line {
  padding-left: 25%;
  margin-bottom: 35px;
  position: relative;
  display: block;
  width: 100%;
}

.typography-line span {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  margin-left: 20px;
  position: absolute;
  width: 260px;
  text-transform: none;
}

.tim-row {
  padding-top: 60px;
}

.tim-row h3 {
  margin-top: 0;
}

.switch {
  margin-right: 20px;
}

#navbar-full .navbar {
  border-radius: 0 !important;
  margin-bottom: 15px;
  z-index: 2;
}

#menu-dropdown .navbar {
  border-radius: 3px;
}

#pagination-row .pagination-container {
  height: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
}

/* Nucelo Icons */

#icons-row i.nc-icons {
  font-size: 30px;
}

.demo-iconshtml {
  font-size: 62.5%;
}

.demo-icons body {
  font-size: 1.6rem;
  font-family: sans-serif;
  color: #333333;
  background: white;
}

.demo-icons a {
  color: #608cee;
  text-decoration: none;
}

.demo-icons header {
  text-align: center;
  padding: 100px 0 0;
}

.demo-icons header h1 {
  font-size: 2.8rem;
}

.demo-icons header p {
  font-size: 1.4rem;
  margin-top: 1em;
}

.demo-icons header a:hover {
  text-decoration: underline;
}

.demo-icons .nc-icon {
  font-size: 34px;
}

.demo-icons section {
  width: 90%;
  max-width: 1200px;
  margin: 50px auto;
}

.demo-icons section h2 {
  border-bottom: 1px solid #e2e2e2;
  padding: 0 0 1em 0.2em;
  margin-bottom: 1em;
}

.demo-icons ul::after {
  clear: both;
  content: "";
  display: table;
}

.demo-icons ul li {
  width: 20%;
  float: left;
  padding: 16px 0;
  text-align: center;
  border-radius: 0.25em;
  transition: background 0.2s;
  -webkit-user-select: none;
  user-select: none;
  overflow: hidden;
}

.demo-icons ul li:hover {
  background: #f4f4f4;
}

.demo-icons ul p,
.demo-icons ul em,
.demo-icons ul input {
  display: inline-block;
  font-size: 1rem;
  color: #999999;
  -webkit-user-select: auto;
  user-select: auto;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.demo-icons ul p {
  padding: 20px 0 0;
  font-size: 12px;
  margin: 0;
}

.demo-icons ul p::selection,
.demo-icons ul em::selection {
  background: #608cee;
  color: #efefef;
}

.demo-icons ul em {
  font-size: 12px;
}

.demo-icons ul em::before {
  content: "[";
}

.demo-icons ul em::after {
  content: "]";
}

.demo-icons ul input {
  text-align: center;
  background: transparent;
  border: none;
  box-shadow: none;
  outline: none;
  display: none;
}

.space {
  height: 130px;
  display: block;
}

.space-110 {
  height: 110px;
  display: block;
}

.space-50 {
  height: 50px;
  display: block;
}

.space-70 {
  height: 70px;
  display: block;
}

.navigation-example {
  background-attachment: scroll;
}

.navigation-example {
  background-position: center center;
  background-size: cover;
  margin-top: 0;
  height: 100%;
}

#notifications {
  background-color: #ffffff;
  display: block;
  width: 100%;
  position: relative;
}

.tim-note {
  text-transform: capitalize;
}

.download-area {
  margin-top: 30px;
}

.sharing-area {
  margin-top: 50px;
}

.sharing-area .btn {
  margin-top: 14px;
}

.upgrade-pro .btn {
  margin-top: 30px;
}

#buttons .btn,
#javascriptComponents .btn {
  margin: 0 0px 10px;
}

.space-100 {
  height: 100px;
  display: block;
  width: 100%;
}

.be-social {
  padding-bottom: 20px;
  /*     border-bottom: 1px solid #aaa; */
  margin: 0 auto 40px;
}

.txt-white {
  color: #ffffff;
}

.txt-gray {
  color: #ddd !important;
}

.parallax {
  width: 100%;
  height: 570px;
  display: block;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.profile-content {
  padding-top: 0;
  position: relative;
  z-index: 2;
}

.logo-container .logo {
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #333333;
  width: 50px;
  float: left;
}

.logo-container .brand {
  font-size: 16px;
  color: #ffffff;
  line-height: 18px;
  float: left;
  margin-left: 10px;
  margin-top: 7px;
  width: 70px;
  height: 40px;
  text-align: left;
}

.logo-container .brand-material {
  font-size: 18px;
  margin-top: 15px;
  height: 25px;
  width: auto;
}

.logo-container .logo img {
  width: 100%;
}

.navbar-small .logo-container .brand {
  color: #333333;
}

.fixed-section {
  top: 90px;
  max-height: 80vh;
  overflow: scroll;
  position: sticky;
}

.fixed-section ul {
  padding: 0;
}

.fixed-section ul li {
  list-style: none;
}

.fixed-section li a {
  font-size: 14px;
  padding: 2px;
  display: block;
  color: #666666;
}

.fixed-section li a.active {
  color: #00bbff;
}

.fixed-section.float {
  position: fixed;
  top: 100px;
  width: 200px;
  margin-top: 0;
}

.parallax .parallax-image {
  width: 100%;
  overflow: hidden;
  position: absolute;
}

.parallax .parallax-image img {
  width: 100%;
}

@media (max-width: 768px) {
  .parallax .parallax-image {
    width: 100%;
    height: 640px;
    overflow: hidden;
  }
  .parallax .parallax-image img {
    height: 100%;
    width: auto;
  }
}

/*.separator{
    content: "Separator";
    color: #FFFFFF;
    display: block;
    width: 100%;
    padding: 20px;
}
.separator-line{
    background-color: #EEE;
    height: 1px;
    width: 100%;
    display: block;
}
.separator.separator-gray{
    background-color: #EEEEEE;
}*/

.social-buttons-demo .btn {
  margin-right: 5px;
  margin-bottom: 7px;
}

.img-container {
  width: 100%;
  overflow: hidden;
}

.img-container img {
  width: 100%;
}

.lightbox img {
  width: 100%;
}

.lightbox .modal-content {
  overflow: hidden;
}

.lightbox .modal-body {
  padding: 0;
}

@media screen and (min-width: 991px) {
  .lightbox .modal-dialog {
    width: 960px;
  }
}

@media (max-width: 991px) {
  .fixed-section.affix {
    position: relative;
    margin-bottom: 100px;
  }
}

@media (max-width: 768px) {
  .btn,
  .btn-morphing {
    margin-bottom: 10px;
  }
  .parallax .motto {
    top: 170px;
    margin-top: 0;
    font-size: 60px;
    width: 270px;
  }
}

/*       Loading dots  */

/*      transitions */

.presentation .front,
.presentation .front:after,
.presentation .front .btn,
.logo-container .logo,
.logo-container .brand {
  transition: all 0.2s;
}

#images h4 {
  margin-bottom: 30px;
}

#javascriptComponents {
  padding-bottom: 0;
}

/*      layer animation          */

.layers-container {
  display: block;
  margin-top: 50px;
  position: relative;
}

.layers-container img {
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  left: 0;
  text-align: center;
}

.animate {
  transition: 1.5s ease-in-out;
  -moz-transition: 1.5s ease-in-out;
  -webkit-transition: 1.5s ease-in-out;
}

.navbar-default.navbar-small .logo-container .brand {
  color: #333333;
}

.navbar-transparent.navbar-small .logo-container .brand {
  color: #ffffff;
}

.navbar-default.navbar-small .logo-container .brand {
  color: #333333;
}

.sharing-area {
  margin-top: 80px;
}

.sharing-area .btn {
  margin: 15px 4px 0;
}

.section-thin,
.section-notifications {
  padding: 0;
}

.section-navbars {
  padding-top: 0;
}

.section-tabs {
  background: #eeeeee;
}

.section-pagination {
  padding-bottom: 0;
}

.section-download {
  padding-top: 130px;
}

.section-download .description {
  margin-bottom: 60px;
}

.section-download h4 {
  margin-bottom: 25px;
}

.section-examples a {
  text-decoration: none;
}

.section-examples a + a {
  margin-top: 30px;
}

.section-examples h5 {
  margin-top: 30px;
}

.components-page .wrapper > .header,
.tutorial-page .wrapper > .header {
  height: 500px;
  padding-top: 128px;
  background-size: cover;
  background-position: center center;
}

.components-page .title,
.tutorial-page .title {
  color: #ffffff;
}

.brand .h1-seo {
  font-size: 2.8em;
  text-transform: uppercase;
  font-weight: 300;
}

.brand .n-logo {
  max-width: 100px;
  margin-bottom: 40px;
}

.invision-logo {
  max-width: 70px;
  top: -2px;
  position: relative;
}

.creative-tim-logo {
  max-width: 140px;
  top: -2px;
  position: relative;
}

.section-javascript .title {
  margin-bottom: 0;
}

.navbar .switch-background {
  display: block;
}

.navbar-transparent .switch-background {
  display: none;
}

.section-signup .col .btn {
  margin-top: 30px;
}

#buttons-row .btn {
  margin-bottom: 10px;
}

.section-basic {
  padding-top: 0;
}

.section-images {
  padding-bottom: 0;
}

@media screen and (max-width: 991px) {
  .section-navbars .navbar-collapse {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/demo/demo.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;CAiBC;AACD;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EAGrB,2BAA2B;EAC3B,yBAAyB;EAGzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,yBAAyB;EAGzB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,aAAa;IACb,eAAe;IACf,YAAY;EACd;AACF;;AAEA,wBAAwB;;AAExB,qBAAqB;;AAErB;;;;;EAQE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;;AAElC;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/*!\r\n\r\n=========================================================\r\n* Paper Kit React - v1.3.2\r\n=========================================================\r\n\r\n* Product Page: https://www.creative-tim.com/product/paper-kit-react\r\n\r\n* Copyright 2023 Creative Tim (https://www.creative-tim.com)\r\n* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)\r\n\r\n* Coded by Creative Tim\r\n\r\n=========================================================\r\n\r\n* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\r\n\r\n*/\r\n.tim-row {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.tim-white-buttons {\r\n  background-color: #777777;\r\n}\r\n\r\n.typography-line {\r\n  padding-left: 25%;\r\n  margin-bottom: 35px;\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.typography-line span {\r\n  bottom: 10px;\r\n  color: #c0c1c2;\r\n  display: block;\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n  line-height: 13px;\r\n  left: 0;\r\n  margin-left: 20px;\r\n  position: absolute;\r\n  width: 260px;\r\n  text-transform: none;\r\n}\r\n\r\n.tim-row {\r\n  padding-top: 60px;\r\n}\r\n\r\n.tim-row h3 {\r\n  margin-top: 0;\r\n}\r\n\r\n.switch {\r\n  margin-right: 20px;\r\n}\r\n\r\n#navbar-full .navbar {\r\n  border-radius: 0 !important;\r\n  margin-bottom: 15px;\r\n  z-index: 2;\r\n}\r\n\r\n#menu-dropdown .navbar {\r\n  border-radius: 3px;\r\n}\r\n\r\n#pagination-row .pagination-container {\r\n  height: 100%;\r\n  max-height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Nucelo Icons */\r\n\r\n#icons-row i.nc-icons {\r\n  font-size: 30px;\r\n}\r\n\r\n.demo-iconshtml {\r\n  font-size: 62.5%;\r\n}\r\n\r\n.demo-icons body {\r\n  font-size: 1.6rem;\r\n  font-family: sans-serif;\r\n  color: #333333;\r\n  background: white;\r\n}\r\n\r\n.demo-icons a {\r\n  color: #608cee;\r\n  text-decoration: none;\r\n}\r\n\r\n.demo-icons header {\r\n  text-align: center;\r\n  padding: 100px 0 0;\r\n}\r\n\r\n.demo-icons header h1 {\r\n  font-size: 2.8rem;\r\n}\r\n\r\n.demo-icons header p {\r\n  font-size: 1.4rem;\r\n  margin-top: 1em;\r\n}\r\n\r\n.demo-icons header a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.demo-icons .nc-icon {\r\n  font-size: 34px;\r\n}\r\n\r\n.demo-icons section {\r\n  width: 90%;\r\n  max-width: 1200px;\r\n  margin: 50px auto;\r\n}\r\n\r\n.demo-icons section h2 {\r\n  border-bottom: 1px solid #e2e2e2;\r\n  padding: 0 0 1em 0.2em;\r\n  margin-bottom: 1em;\r\n}\r\n\r\n.demo-icons ul::after {\r\n  clear: both;\r\n  content: \"\";\r\n  display: table;\r\n}\r\n\r\n.demo-icons ul li {\r\n  width: 20%;\r\n  float: left;\r\n  padding: 16px 0;\r\n  text-align: center;\r\n  border-radius: 0.25em;\r\n  -webkit-transition: background 0.2s;\r\n  -moz-transition: background 0.2s;\r\n  transition: background 0.2s;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  overflow: hidden;\r\n}\r\n\r\n.demo-icons ul li:hover {\r\n  background: #f4f4f4;\r\n}\r\n\r\n.demo-icons ul p,\r\n.demo-icons ul em,\r\n.demo-icons ul input {\r\n  display: inline-block;\r\n  font-size: 1rem;\r\n  color: #999999;\r\n  -webkit-user-select: auto;\r\n  -moz-user-select: auto;\r\n  -ms-user-select: auto;\r\n  user-select: auto;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  cursor: pointer;\r\n}\r\n\r\n.demo-icons ul p {\r\n  padding: 20px 0 0;\r\n  font-size: 12px;\r\n  margin: 0;\r\n}\r\n\r\n.demo-icons ul p::selection,\r\n.demo-icons ul em::selection {\r\n  background: #608cee;\r\n  color: #efefef;\r\n}\r\n\r\n.demo-icons ul em {\r\n  font-size: 12px;\r\n}\r\n\r\n.demo-icons ul em::before {\r\n  content: \"[\";\r\n}\r\n\r\n.demo-icons ul em::after {\r\n  content: \"]\";\r\n}\r\n\r\n.demo-icons ul input {\r\n  text-align: center;\r\n  background: transparent;\r\n  border: none;\r\n  box-shadow: none;\r\n  outline: none;\r\n  display: none;\r\n}\r\n\r\n.space {\r\n  height: 130px;\r\n  display: block;\r\n}\r\n\r\n.space-110 {\r\n  height: 110px;\r\n  display: block;\r\n}\r\n\r\n.space-50 {\r\n  height: 50px;\r\n  display: block;\r\n}\r\n\r\n.space-70 {\r\n  height: 70px;\r\n  display: block;\r\n}\r\n\r\n.navigation-example {\r\n  background-attachment: scroll;\r\n}\r\n\r\n.navigation-example {\r\n  background-position: center center;\r\n  background-size: cover;\r\n  margin-top: 0;\r\n  height: 100%;\r\n}\r\n\r\n#notifications {\r\n  background-color: #ffffff;\r\n  display: block;\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.tim-note {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.download-area {\r\n  margin-top: 30px;\r\n}\r\n\r\n.sharing-area {\r\n  margin-top: 50px;\r\n}\r\n\r\n.sharing-area .btn {\r\n  margin-top: 14px;\r\n}\r\n\r\n.upgrade-pro .btn {\r\n  margin-top: 30px;\r\n}\r\n\r\n#buttons .btn,\r\n#javascriptComponents .btn {\r\n  margin: 0 0px 10px;\r\n}\r\n\r\n.space-100 {\r\n  height: 100px;\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.be-social {\r\n  padding-bottom: 20px;\r\n  /*     border-bottom: 1px solid #aaa; */\r\n  margin: 0 auto 40px;\r\n}\r\n\r\n.txt-white {\r\n  color: #ffffff;\r\n}\r\n\r\n.txt-gray {\r\n  color: #ddd !important;\r\n}\r\n\r\n.parallax {\r\n  width: 100%;\r\n  height: 570px;\r\n  display: block;\r\n  background-attachment: fixed;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center center;\r\n}\r\n\r\n.profile-content {\r\n  padding-top: 0;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.logo-container .logo {\r\n  overflow: hidden;\r\n  border-radius: 50%;\r\n  border: 1px solid #333333;\r\n  width: 50px;\r\n  float: left;\r\n}\r\n\r\n.logo-container .brand {\r\n  font-size: 16px;\r\n  color: #ffffff;\r\n  line-height: 18px;\r\n  float: left;\r\n  margin-left: 10px;\r\n  margin-top: 7px;\r\n  width: 70px;\r\n  height: 40px;\r\n  text-align: left;\r\n}\r\n\r\n.logo-container .brand-material {\r\n  font-size: 18px;\r\n  margin-top: 15px;\r\n  height: 25px;\r\n  width: auto;\r\n}\r\n\r\n.logo-container .logo img {\r\n  width: 100%;\r\n}\r\n\r\n.navbar-small .logo-container .brand {\r\n  color: #333333;\r\n}\r\n\r\n.fixed-section {\r\n  top: 90px;\r\n  max-height: 80vh;\r\n  overflow: scroll;\r\n  position: sticky;\r\n}\r\n\r\n.fixed-section ul {\r\n  padding: 0;\r\n}\r\n\r\n.fixed-section ul li {\r\n  list-style: none;\r\n}\r\n\r\n.fixed-section li a {\r\n  font-size: 14px;\r\n  padding: 2px;\r\n  display: block;\r\n  color: #666666;\r\n}\r\n\r\n.fixed-section li a.active {\r\n  color: #00bbff;\r\n}\r\n\r\n.fixed-section.float {\r\n  position: fixed;\r\n  top: 100px;\r\n  width: 200px;\r\n  margin-top: 0;\r\n}\r\n\r\n.parallax .parallax-image {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: absolute;\r\n}\r\n\r\n.parallax .parallax-image img {\r\n  width: 100%;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .parallax .parallax-image {\r\n    width: 100%;\r\n    height: 640px;\r\n    overflow: hidden;\r\n  }\r\n  .parallax .parallax-image img {\r\n    height: 100%;\r\n    width: auto;\r\n  }\r\n}\r\n\r\n/*.separator{\r\n    content: \"Separator\";\r\n    color: #FFFFFF;\r\n    display: block;\r\n    width: 100%;\r\n    padding: 20px;\r\n}\r\n.separator-line{\r\n    background-color: #EEE;\r\n    height: 1px;\r\n    width: 100%;\r\n    display: block;\r\n}\r\n.separator.separator-gray{\r\n    background-color: #EEEEEE;\r\n}*/\r\n\r\n.social-buttons-demo .btn {\r\n  margin-right: 5px;\r\n  margin-bottom: 7px;\r\n}\r\n\r\n.img-container {\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.img-container img {\r\n  width: 100%;\r\n}\r\n\r\n.lightbox img {\r\n  width: 100%;\r\n}\r\n\r\n.lightbox .modal-content {\r\n  overflow: hidden;\r\n}\r\n\r\n.lightbox .modal-body {\r\n  padding: 0;\r\n}\r\n\r\n@media screen and (min-width: 991px) {\r\n  .lightbox .modal-dialog {\r\n    width: 960px;\r\n  }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .fixed-section.affix {\r\n    position: relative;\r\n    margin-bottom: 100px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .btn,\r\n  .btn-morphing {\r\n    margin-bottom: 10px;\r\n  }\r\n  .parallax .motto {\r\n    top: 170px;\r\n    margin-top: 0;\r\n    font-size: 60px;\r\n    width: 270px;\r\n  }\r\n}\r\n\r\n/*       Loading dots  */\r\n\r\n/*      transitions */\r\n\r\n.presentation .front,\r\n.presentation .front:after,\r\n.presentation .front .btn,\r\n.logo-container .logo,\r\n.logo-container .brand {\r\n  -webkit-transition: all 0.2s;\r\n  -moz-transition: all 0.2s;\r\n  -o-transition: all 0.2s;\r\n  transition: all 0.2s;\r\n}\r\n\r\n#images h4 {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n#javascriptComponents {\r\n  padding-bottom: 0;\r\n}\r\n\r\n/*      layer animation          */\r\n\r\n.layers-container {\r\n  display: block;\r\n  margin-top: 50px;\r\n  position: relative;\r\n}\r\n\r\n.layers-container img {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: auto;\r\n  top: 0;\r\n  left: 0;\r\n  text-align: center;\r\n}\r\n\r\n.animate {\r\n  transition: 1.5s ease-in-out;\r\n  -moz-transition: 1.5s ease-in-out;\r\n  -webkit-transition: 1.5s ease-in-out;\r\n}\r\n\r\n.navbar-default.navbar-small .logo-container .brand {\r\n  color: #333333;\r\n}\r\n\r\n.navbar-transparent.navbar-small .logo-container .brand {\r\n  color: #ffffff;\r\n}\r\n\r\n.navbar-default.navbar-small .logo-container .brand {\r\n  color: #333333;\r\n}\r\n\r\n.sharing-area {\r\n  margin-top: 80px;\r\n}\r\n\r\n.sharing-area .btn {\r\n  margin: 15px 4px 0;\r\n}\r\n\r\n.section-thin,\r\n.section-notifications {\r\n  padding: 0;\r\n}\r\n\r\n.section-navbars {\r\n  padding-top: 0;\r\n}\r\n\r\n.section-tabs {\r\n  background: #eeeeee;\r\n}\r\n\r\n.section-pagination {\r\n  padding-bottom: 0;\r\n}\r\n\r\n.section-download {\r\n  padding-top: 130px;\r\n}\r\n\r\n.section-download .description {\r\n  margin-bottom: 60px;\r\n}\r\n\r\n.section-download h4 {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.section-examples a {\r\n  text-decoration: none;\r\n}\r\n\r\n.section-examples a + a {\r\n  margin-top: 30px;\r\n}\r\n\r\n.section-examples h5 {\r\n  margin-top: 30px;\r\n}\r\n\r\n.components-page .wrapper > .header,\r\n.tutorial-page .wrapper > .header {\r\n  height: 500px;\r\n  padding-top: 128px;\r\n  background-size: cover;\r\n  background-position: center center;\r\n}\r\n\r\n.components-page .title,\r\n.tutorial-page .title {\r\n  color: #ffffff;\r\n}\r\n\r\n.brand .h1-seo {\r\n  font-size: 2.8em;\r\n  text-transform: uppercase;\r\n  font-weight: 300;\r\n}\r\n\r\n.brand .n-logo {\r\n  max-width: 100px;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.invision-logo {\r\n  max-width: 70px;\r\n  top: -2px;\r\n  position: relative;\r\n}\r\n\r\n.creative-tim-logo {\r\n  max-width: 140px;\r\n  top: -2px;\r\n  position: relative;\r\n}\r\n\r\n.section-javascript .title {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.navbar .switch-background {\r\n  display: block;\r\n}\r\n\r\n.navbar-transparent .switch-background {\r\n  display: none;\r\n}\r\n\r\n.section-signup .col .btn {\r\n  margin-top: 30px;\r\n}\r\n\r\n#buttons-row .btn {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.section-basic {\r\n  padding-top: 0;\r\n}\r\n\r\n.section-images {\r\n  padding-bottom: 0;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .section-navbars .navbar-collapse {\r\n    display: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
